module.exports = __webpack_public_path__ + "static/media/matthew-brodeur-3445-unsplash.d7b94644.png";